import { IconButton, Menu } from "@mui/material";
import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteSectionItem from "components/ai-editor/DeleteSectionItem";

export default function SectionMenu({ section, menuItems }) {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {React.Children.map(menuItems, (child) =>
          React.isValidElement(child)
          ? React.cloneElement(child, { handleClose })
          : null
        )}
        <DeleteSectionItem 
          section={section} 
          handleClose={handleClose} 
        />
      </Menu>
    </>
  );
}
